module.exports = __webpack_public_path__ + "static/searchinput-context-do-ea6916e487c72c35e80a3ce46da4afbf.png";